import React from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { selectOpenedModalType } from '../../../../redux/selectors/modal';
import { ModalSliceType } from '../../../../redux/slices/modal';
import DeleteTileModal from './DeleteTileModal';
import UpsertTileModal from './UpsertTileModal';

const TileModals = () => {
  const isDeleteTileModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.DeleteTile, ''),
  );
  const isUpsertTileModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.UpsertTile, ''),
  );

  if (isDeleteTileModalOpen) {
    return <DeleteTileModal />;
  }

  if (isUpsertTileModalOpen) {
    return <UpsertTileModal />;
  }

  return null;
};

export default TileModals;
